// Redux 5 soft-deprecates `createStore` in favor of Redux Toolkit's
// `configureStore`; this app deliberately stays on the plain store (saga +
// devtools wiring below), so we import the un-deprecated alias.
import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootSaga from './sagas';
import createReducer from './reducers';

const sagaMiddleware = createSagaMiddleware();
const devtools = window.__REDUX_DEVTOOLS_EXTENSION__ || (() => noop => noop);

const configureStore = (initialState = {}) => {
  const middlewares = [
    sagaMiddleware,
  ];

  const enhancers = [
    applyMiddleware(...middlewares),
    devtools(),
  ];

  const store = createStore(
    createReducer,
    initialState,
    compose(...enhancers)
  );

  sagaMiddleware.run(rootSaga);

  // Reducer hot-reload (dev-only DX). CRA/webpack exposed `module.hot`; under
  // Vite the equivalent is `import.meta.hot`. A BARE `module.hot` reference
  // throws `ReferenceError: module is not defined` in a Vite production bundle
  // (webpack defined `module`, Vite does not) — which white-screened the app.
  // `import.meta.hot` is undefined in any production build, so this whole block
  // is a no-op there; in `vite` dev it swaps the reducer without losing state.
  // Vite passes the freshly-loaded module to the accept callback (no `require`).
  if (import.meta.hot) {
    import.meta.hot.accept('./reducers', (nextModule) => {
      if (nextModule) {
        store.replaceReducer(nextModule.default);
      }
    });
  }
  return store;
}

export default configureStore;
